import React from 'react';
import { Box } from '@mui/material';

const CARD_SHADOW =
  '0px 1px 2px 0px rgba(162, 172, 177, 0.2), 0px 12px 24px -4px rgba(22, 47, 59, 0.12)';

const richTextStyles = {
  '& p': {
    margin: 0,
  },
  '& p + p': {
    marginTop: '1.25rem',
  },
  '& a': {
    color: '#162F3B',
  },
  '& strong': {
    fontWeight: 700,
  },
};

const GenericTextBlockMobileComponent = ({ data }) => {
  const { title = '', description = '' } = data || {};

  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        maxWidth: '100vw',
        px: '16px',
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          width: '100%',
          backgroundColor: '#FFFFFF',
          borderRadius: '24px',
          boxShadow: CARD_SHADOW,
          px: '20px',
          py: '24px',
          boxSizing: 'border-box',
        }}
      >
        <Box
          component="div"
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 700,
            fontSize: '2rem',
            lineHeight: '2.25rem',
            letterSpacing: '-0.03em',
            textAlign: 'center',
            color: '#162F3B',
            mb: '16px',
            ...richTextStyles,
          }}
          dangerouslySetInnerHTML={{ __html: title }}
        />

        <Box
          component="div"
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: '1rem',
            lineHeight: '1.4rem',
            letterSpacing: '-0.03em',
            textAlign: 'center',
            color: '#162F3B',
            ...richTextStyles,
          }}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </Box>
    </Box>
  );
};

export default GenericTextBlockMobileComponent;
